<div
  ngbDropdown
  #searchDropdown="ngbDropdown"
  class="search-dropdown-wrapper"
  (openChange)="onOpenChange($event)"
  [autoClose]="isMobile ? false : 'outside'"
  [class.is-mobile]="isMobile"
>
  <span class="dropdown-anchor" ngbDropdownAnchor></span>

  <div
    class="search-input-fake"
    [class.search-input--focused]="isOpen"
    (click)="onInputFocus($event, searchDropdown)"
  >
    <span
      class="search-text-wrapper"
      *ngIf="searchDropdown && !isMobile"
    >
      <img
        src="assets/icons/search-2.svg"
        alt="search-icon"
      />
    </span>

    <app-input
      class="search-text-wrapper"
      placeholder="Search sports or events"
      [fc]="innerForm.controls.searchQuery"
      [readonly]="isMobile"
      [focus]="isOpen && !isMobile"
    ></app-input>

    <app-badge-row
      *ngIf="isCategorySelected"
      [max]="isMobile ? 1 : 0"
      [onlyCounter]="!isMobile"
      [items]="selectedCategoryBadges"
      units="Sports"
      (click)="onInputFocus($event, searchDropdown)"
      (closeClicked)="onCategoryRemove($event)"
    ></app-badge-row>
  </div>

  <div class="search-dropdown" ngbDropdownMenu>
    <div *ngrxLet="results$; let results" class="dropdown-inner">
      <div
        *ngIf="
          !results ||
          (results?.categories.length === 0 && results?.events.length === 0) ||
          forceNoResults
        "
        class="search-dropdown__events pl-4 pr-4"
      >
        No results found!
      </div>

      <ng-container
        *ngIf="results?.categories.length && !forceNoResults && !showMoreEvents"
      >
        <div *ngIf="isCategorySelected" class="search-dropdown__categories">
          <span class="dropdown-title">Selected Sports</span>

          <div class="category-list">
            <span
              *ngFor="let category of selectedState.categories"
              class="category-list__title closable category-item"
              (click)="onCategoryRemove(category.category_id)"
            >
              {{ category.category_title }}
            </span>
          </div>
        </div>

        <div
          *ngIf="getUnselectedCategories(results?.categories ?? []).length"
          class="search-dropdown__categories"
        >
          <span class="dropdown-title">
            <span *ngIf="isCategorySelected">Other </span>Sports
          </span>

          <div class="category-list">
            <span
              *ngFor="
                let category of getUnselectedCategories(
                  results?.categories ?? []
                )
              "
              class="category-list__title category-item"
              (click)="onCategoryAdd(category)"
            >
              {{ category.category_title }}
            </span>
          </div>

          <span
            *ngIf="defaultCategoryListCount < results?.categories?.length ?? 0"
            class="show-action action-color semi-bold pointer"
            (click)="showMoreCategories = !showMoreCategories"
          >
            <ng-container *ngIf="!showMoreCategories">Show more</ng-container>
            <ng-container *ngIf="showMoreCategories">Show less</ng-container>
          </span>
        </div>
      </ng-container>

      <div
        *ngIf="
          results?.events.length &&
          !isCategorySelected &&
          !isSearchTermEmpty &&
          !forceNoResults &&
          !showMoreCategories
        "
        class="search-dropdown__events"
      >
        <span class="dropdown-title">{{ 'events' | t }}</span>

        <div class="event-list">
          <button
            *ngFor="let event of getEventList(results?.events) ?? []"
            ngbDropdownItem
            (click)="goToEventPage(event)"
          >
            <app-entity-logo class="logo" [logo]="event.logo_image"></app-entity-logo>
            <div>
              <span class="event-list__title">{{ event.event_name }}</span>
              <span class="event-list__place-date">
                {{ parseLocation(event.event_location) }} •
                {{ event.event_start | date: "EEE, MMM d • H:mm" }}</span
              >
            </div>
          </button>
        </div>

        <span
          *ngIf="defaultEventListCount < results?.events?.length ?? 0"
          class="show-action action-color semi-bold pointer"
          (click)="showMoreEvents = !showMoreEvents"
        >
          <ng-container *ngIf="!showMoreEvents">Show more</ng-container>
          <ng-container *ngIf="showMoreEvents">Show less</ng-container>
        </span>
      </div>
    </div>

    <app-input
      *ngIf="isMobile"
      class="search-input"
      placeholder="Search sports or events"
      [fc]="innerForm.controls.searchQuery"
      [focus]="isOpen && isMobile"
    ></app-input>
  </div>
</div>
